import React from 'react';
import { SearchBox } from '../../../common/sharedComponents/SearchBox';
import { ISelectedOption } from '../../../@types/searchBox';
import { useTranslation } from 'react-i18next';
import {
  filterOptions,
  handleOptionClickUtil,
} from '../../../common/sharedComponents/SearchBox/utils';
import { useSearchUser } from '../../../common/hooks/useSearchUser';

export function SearchBoxUser ({
  callBackSelectedOptions,
  selectedUser,
  disabled,
}) {
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchUser(selectedUser);

  function handleInputChange (value: string) {
    setSearchText(value);
    const filteredOption =  filterOptions(value, searchBoxOptions);
    setSearchBoxOptions(filteredOption);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      callBackSelectedOptions([...selectedOptions, ...selectedOption]);
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function clearSearch () {
    setSearchText('');
    setSelectedOptions([]);
    callBackSelectedOptions([]);
  }

  return (
    <SearchBox
      handleInputChange={handleInputChange}
      searchBoxOptions={searchBoxOptions}
      handleOptionClick={handleOptionClick}
      selectedOptions={selectedOptions}
      searchTextName={searchText}
      clearSearch={clearSearch}
      placeholderText={t(
        'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
      )}
      disabled={disabled}
    />
  );
}
